import React, { useContext } from 'react';
import { Grid } from '@mui/material';
import { useForm } from 'react-hook-form';
import { useNavigate, useParams } from 'react-router-dom';
import { decryptURL } from 'utils/functions';
import { CrmContext } from 'contexts/CrmContext';
import { DropsContext } from 'contexts/DropsContext';
import VirtualDrop from 'components/VirtualDrop';
import Container from 'components/Container';
import InputMask from 'components/InputMask';
import Button from 'components/Button';
import Header from 'components/Header';
import Input from 'components/Input';

const Gerar = () => {
  const { hash = '' } = useParams();
  const lead = decryptURL(hash);
  const { drops } = useContext(DropsContext);
  const { postLead, postLoading } = useContext(CrmContext);
  const defaultValues = {
    id: lead?.id || null,
    entidade_id: lead?.entidade_id || null,
    nome: lead?.nome || '',
    contato: lead?.contato || '',
    email: lead?.email || '',
    fone: lead?.fone || '',
    whatsapp: lead?.whatsapp || '',
    cidade_id: lead?.cidade_id || null,
    valor: lead?.valor || '',
    origem: lead?.origem || null,
    documento_id: lead?.documento_id || null,
    descricao: lead?.descricao || '',
    funil_id: lead?.funil_id || null,
  };
  const navigate = useNavigate();
  const { control, handleSubmit } = useForm({ defaultValues });

  const onSubmit = (data) => {
    postLead({ data, cb: () => navigate(-1) });
  };

  return (
    <Container>
      <Header titulo={Boolean(lead) ? 'Editar Lead' : 'Adicionar Lead'} />
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <VirtualDrop
            name="entidade_id"
            control={control}
            label="Entidade"
            options={drops?.Entidade}
            refresh="Entidade"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Input name="nome" control={control} label="Nome (Empresa)" />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Input name="contato" control={control} label="Contato (Pessoa)" />
        </Grid>
        <Grid item xs={12} sm={3}>
          <Input name="email" control={control} label="E-mail" />
        </Grid>
        <Grid item xs={12} sm={3}>
          <InputMask
            name="fone"
            label="Telefone"
            control={control}
            mask="(99) 9999-9999"
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <InputMask
            name="whatsapp"
            label="WhatsApp"
            control={control}
            mask="(99) 99999-9999"
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <VirtualDrop
            name="cidade_id"
            control={control}
            label="Cidade"
            options={drops?.Cidade}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <InputMask name="valor" control={control} label="Valor" />
        </Grid>
        <Grid item xs={12} sm={6}>
          <VirtualDrop
            name="funil_id"
            control={control}
            label="Etapa do Funil"
            options={drops?.CrmFunil?.filter((f) => f?.manual === 'SIM')}
          />
        </Grid>
        <Grid item xs={12}>
          <Input
            name="descricao"
            control={control}
            label="Descrição"
            multiline
            rows={5}
          />
        </Grid>
        <Grid item xs={12} textAlign="center">
          <Button
            variant="contained"
            color="primary"
            loading={postLoading}
            onClick={handleSubmit(onSubmit)}
          >
            Salvar
          </Button>
        </Grid>
      </Grid>
    </Container>
  );
};

export default Gerar;
